import { BaseModel } from "sjs-base-model";
import ControlloModel from "./ControlloModel";
import TassiModel from "./TassiModel";
import ValoriModel from "./ValoriModel";
import ValoriModelExtended from "./ValoriModelExtended";
import SimulazioneCreditoNetTableModel from "./SimulazioneCreditoNetTableModel";
import SimulazioneRichiestaCedibilitaTableModel from "./SimulazioneRichiestaCedibilitaTableModel";
import ValoriInterfaccia from "./ValoriInterfacciaModel";

export default class SimulazioneModel extends BaseModel {
    public readonly idSimulation: number = 0;
    public readonly idRequestType: number = 0;
    public readonly idProduct: number = 0;
    public readonly idMacroProduct: number = 0;
    public readonly interestAmount: number = 0;
    public readonly preliminaryCosts: ValoriModelExtended = new ValoriModelExtended({});
    public readonly stampDuty: number = 0;
    public readonly tan: number = 0;
    public readonly tanBase: number = 0;
    public readonly taeg: number | undefined = undefined;
    public readonly teg: number | undefined = undefined;
    public readonly irr: number = 0;
    public readonly amount: number = 0;
    public readonly salary: number = 0;
    public readonly balance: number = 0;
    public readonly intermediationCosts: ValoriModel = new ValoriModel({});
    // public readonly expirationDate: string = "";
    public readonly vaCapital: number = 0;
    public readonly charges: number = 0;
    public readonly maxPercOverAmount: ValoriModel = new ValoriModel({});
    public readonly bankCommissions: ValoriModel = new ValoriModel({});
    public readonly reportingBankCommissions: ValoriModelExtended = new ValoriModelExtended({});
    public readonly extraCommissions: ValoriModel = new ValoriModel({});
    public readonly guid: string = "";
    public readonly cessionaryCommissions: ValoriModel = new ValoriModel({});
    public readonly upFrontCommissions: ValoriModel = new ValoriModel({});
    public readonly runningCommissions: ValoriModel = new ValoriModel({});
    public readonly preloadedCommissions: ValoriModel = new ValoriModel({});
    public readonly effectiveDate: string = "";
    public readonly instalment: number = 0;
    public readonly idConvention: number = 0;
    public readonly agentCommissions: ValoriModel = new ValoriModel({});
    public readonly wearRates: TassiModel[] = [];
    public readonly duration: number = 0;
    public readonly errors?: ControlloModel[] = [];
    public readonly warnings?: ControlloModel[] = [];
    public readonly maxTotalCommissions: ValoriModel = new ValoriModel({});
    public readonly idInsuranceRc: number = 0;
    public readonly idInsuranceRv: number = 0;
    public readonly idInsurancePriceListRc: number = 0;
    public readonly idInsurancePriceListRv: number = 0;
    public readonly idSegment: number = 0;
    public readonly idChannel: number = 0;
    public readonly fnPunctualInsuranceCosts: boolean = false;
    public readonly idSubLevel?: number;
    public readonly idPracticeType?: number;
    public readonly creditoNetInfos?: SimulazioneCreditoNetTableModel[];
    public readonly transferRequestInfos?: SimulazioneRichiestaCedibilitaTableModel[];
    public readonly dataRinnovoCq?: string;
    public readonly rataRinnovoCq?: number = 0;
    public readonly mesiRinnovoCq?: string;
    public readonly idCertificazioneMail?: Number | undefined;
    public readonly valoriInterfaccia: ValoriInterfaccia = new ValoriInterfaccia({});
    public readonly segnalazione: string = "0";
    public readonly dipendenteBanca: boolean = false;
    public readonly idMotivCambioTan?: number;

    constructor(data: Partial<SimulazioneModel>) {
        super();

        this.update(data);
    }
}
